export const COOKIE_OPTIONS: ICookieOptions = {
  secure: true,
  domain: '.airbaltic.com',
  sameSite: 'lax'
}
